import type { GlyphVariant, PaperVariant } from "./glyphs.ts";

export interface RuledPlacement {
  x: number;
  row: number;
  fontSize: number;
  maxWidth: number;
  verticalScale?: number;
}

export function mobilePaperAspect(clueCount: number): number {
  return clueCount > 4 ? 3 / 7 : 3 / 5;
}

export function paperRuling(paper: PaperVariant): NonNullable<PaperVariant["ruling"]> {
  return paper.ruling ?? {
    firstLine: paper.height * (185 / 1900),
    spacing: paper.height * (76 / 1900),
    rotation: 0,
  };
}

export function ruleBaseline(paper: PaperVariant, row: number): number {
  const ruling = paperRuling(paper);
  return ruling.firstLine + row * ruling.spacing;
}

export function glyphFrames(
  glyph: GlyphVariant,
  paper: PaperVariant,
  placement: RuledPlacement,
) {
  const scale = Math.min(
    placement.fontSize / (glyph.fontSize ?? glyph.height),
    placement.maxWidth / glyph.width,
  );
  const scaleY = scale * (placement.verticalScale ?? 1);
  const lines = glyph.lines ?? [{ top: 0, bottom: glyph.height, baseline: glyph.baseline }];

  return lines.map((line, index) => {
    const baseline = ruleBaseline(paper, placement.row + index);
    return {
      x: placement.x,
      y: baseline - (line.baseline - line.top) * scaleY,
      width: glyph.width * scale,
      height: (line.bottom - line.top) * scaleY,
      baseline,
      baselineOffset: (line.baseline - line.top) * scaleY,
      sourceTop: line.top,
      sourceHeight: line.bottom - line.top,
    };
  });
}